/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const DO_YOU_WANT_TO_SET = 'Do you want to set';
export const AS_THE_DEFAULT_POLICY = 'as the default policy?';
export const SET_AS_DEFAULT = 'Set As Default';
export const CANCEL_BTN_TEXT = 'Cancel';
export const SET_AS_DEFAULT_SUCCESS = 'Password policy {0} successfully set as default.';
export const SET_AS_DEFAULT_ERROR = 'Request error';
